export const storageAdministratorAbi = [
  {
    inputs: [
      { internalType: "address", name: "_rolesManager", type: "address" },
      { internalType: "address", name: "_initialOwner", type: "address" },
      { internalType: "address", name: "_pauser", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  { inputs: [], name: "AccessDenied", type: "error" },
  { inputs: [], name: "EnforcedPause", type: "error" },
  { inputs: [], name: "ExpectedPause", type: "error" },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
  { inputs: [], name: "V1", type: "error" },
  { inputs: [], name: "V8", type: "error" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "ACCOUNT_MANAGER",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MEMBERSHIP_CONTRACT_ADDRESS",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NFT_ID_COUNTER",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NFT_STORAGE",
    outputs: [
      { internalType: "contract INFTStorage", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "POI_CONTRACT_ADDRESS",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "POI_STORAGE",
    outputs: [
      { internalType: "contract IPOIStorage", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ROLES_MANAGER",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "string", name: "name", type: "string" },
          { internalType: "uint96", name: "nftImgId", type: "uint96" },
          { internalType: "uint96", name: "NFT_COLLECTION_ID", type: "uint96" },
          { internalType: "uint96", name: "tokenId", type: "uint96" },
          { internalType: "address", name: "ownerAddress", type: "address" },
          { internalType: "string", name: "referralsLink", type: "string" },
          { internalType: "uint96[]", name: "leftSide", type: "uint96[]" },
          { internalType: "uint96[]", name: "rightSide", type: "uint96[]" },
          { internalType: "uint96", name: "planId", type: "uint96" },
          { internalType: "uint256", name: "createdAt", type: "uint256" },
          {
            internalType: "uint256",
            name: "membershipPlanBoughtDate",
            type: "uint256",
          },
        ],
        internalType: "struct INFTStorageData.NftAccount",
        name: "_data",
        type: "tuple",
      },
      { internalType: "address", name: "_sponsorAddress", type: "address" },
      { internalType: "uint96", name: "_sponsorNFTId", type: "uint96" },
      { internalType: "string", name: "_referralLink", type: "string" },
      { internalType: "uint8", name: "_side", type: "uint8" },
      { internalType: "string", name: "_ipfsLink", type: "string" },
    ],
    name: "createNFTAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "string", name: "fullName", type: "string" },
          { internalType: "string", name: "userName", type: "string" },
          { internalType: "string", name: "email", type: "string" },
          { internalType: "string", name: "phone", type: "string" },
          { internalType: "string", name: "gender", type: "string" },
          { internalType: "string", name: "country", type: "string" },
          { internalType: "uint256", name: "birthdate", type: "uint256" },
          { internalType: "string", name: "image", type: "string" },
          {
            components: [
              { internalType: "string", name: "instagram", type: "string" },
              { internalType: "string", name: "facebook", type: "string" },
              { internalType: "string", name: "tiktok", type: "string" },
              { internalType: "string", name: "youtube", type: "string" },
            ],
            internalType: "struct IPOIStorageData.SocialMedia",
            name: "socials",
            type: "tuple",
          },
          { internalType: "uint256", name: "createdAt", type: "uint256" },
        ],
        internalType: "struct IPOIStorageData.User",
        name: "_user",
        type: "tuple",
      },
      { internalType: "address", name: "_userAddress", type: "address" },
    ],
    name: "createPOIUser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyUnpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "getMyDirectSponsorAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "getMyNFTIds",
    outputs: [{ internalType: "uint96[]", name: "", type: "uint96[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint96", name: "_myNFTId", type: "uint96" }],
    name: "getMySponsorNFTId",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint96", name: "_id", type: "uint96" }],
    name: "getNFTAccountById",
    outputs: [
      {
        components: [
          { internalType: "string", name: "name", type: "string" },
          { internalType: "uint96", name: "nftImgId", type: "uint96" },
          { internalType: "uint96", name: "NFT_COLLECTION_ID", type: "uint96" },
          { internalType: "uint96", name: "tokenId", type: "uint96" },
          { internalType: "address", name: "ownerAddress", type: "address" },
          { internalType: "string", name: "referralsLink", type: "string" },
          { internalType: "uint96[]", name: "leftSide", type: "uint96[]" },
          { internalType: "uint96[]", name: "rightSide", type: "uint96[]" },
          { internalType: "uint96", name: "planId", type: "uint96" },
          { internalType: "uint256", name: "createdAt", type: "uint256" },
          {
            internalType: "uint256",
            name: "membershipPlanBoughtDate",
            type: "uint256",
          },
        ],
        internalType: "struct INFTStorageData.NftAccount",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNFTLastImageUsed",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint96[]", name: "_nftIds", type: "uint96[]" }],
    name: "getNftIPFSLinkBulk",
    outputs: [{ internalType: "string[]", name: "", type: "string[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPOIWalletsWithPOI",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "_link", type: "string" }],
    name: "getSponsorAddressByReferralLink",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "getSponsorDataByAddress",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "_link", type: "string" }],
    name: "getSponsorNFTIdByRefLink",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalUserRegistered",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint96[]", name: "_ids", type: "uint96[]" }],
    name: "getUserNftAccDataBulk",
    outputs: [
      {
        components: [
          { internalType: "string", name: "name", type: "string" },
          { internalType: "uint96", name: "nftImgId", type: "uint96" },
          { internalType: "uint96", name: "NFT_COLLECTION_ID", type: "uint96" },
          { internalType: "uint96", name: "tokenId", type: "uint96" },
          { internalType: "address", name: "ownerAddress", type: "address" },
          { internalType: "string", name: "referralsLink", type: "string" },
          { internalType: "uint96[]", name: "leftSide", type: "uint96[]" },
          { internalType: "uint96[]", name: "rightSide", type: "uint96[]" },
          { internalType: "uint96", name: "planId", type: "uint96" },
          { internalType: "uint256", name: "createdAt", type: "uint256" },
          {
            internalType: "uint256",
            name: "membershipPlanBoughtDate",
            type: "uint256",
          },
        ],
        internalType: "struct INFTStorageData.NftAccount[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "getUserPOIData",
    outputs: [
      {
        components: [
          { internalType: "string", name: "fullName", type: "string" },
          { internalType: "string", name: "userName", type: "string" },
          { internalType: "string", name: "email", type: "string" },
          { internalType: "string", name: "phone", type: "string" },
          { internalType: "string", name: "gender", type: "string" },
          { internalType: "string", name: "country", type: "string" },
          { internalType: "uint256", name: "birthdate", type: "uint256" },
          { internalType: "string", name: "image", type: "string" },
          {
            components: [
              { internalType: "string", name: "instagram", type: "string" },
              { internalType: "string", name: "facebook", type: "string" },
              { internalType: "string", name: "tiktok", type: "string" },
              { internalType: "string", name: "youtube", type: "string" },
            ],
            internalType: "struct IPOIStorageData.SocialMedia",
            name: "socials",
            type: "tuple",
          },
          { internalType: "uint256", name: "createdAt", type: "uint256" },
        ],
        internalType: "struct IPOIStorageData.User",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_walletAddresses",
        type: "address[]",
      },
    ],
    name: "getUserPOIDataBulk",
    outputs: [
      {
        components: [
          { internalType: "string", name: "fullName", type: "string" },
          { internalType: "string", name: "userName", type: "string" },
          { internalType: "string", name: "email", type: "string" },
          { internalType: "string", name: "phone", type: "string" },
          { internalType: "string", name: "gender", type: "string" },
          { internalType: "string", name: "country", type: "string" },
          { internalType: "uint256", name: "birthdate", type: "uint256" },
          { internalType: "string", name: "image", type: "string" },
          {
            components: [
              { internalType: "string", name: "instagram", type: "string" },
              { internalType: "string", name: "facebook", type: "string" },
              { internalType: "string", name: "tiktok", type: "string" },
              { internalType: "string", name: "youtube", type: "string" },
            ],
            internalType: "struct IPOIStorageData.SocialMedia",
            name: "socials",
            type: "tuple",
          },
          { internalType: "uint256", name: "createdAt", type: "uint256" },
        ],
        internalType: "struct IPOIStorageData.User[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint96", name: "_fromIndex", type: "uint96" },
      { internalType: "uint96", name: "_limit", type: "uint96" },
    ],
    name: "getUsersRegisteredBulk",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "isUserRegistered",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_address", type: "address" },
      {
        internalType: "enum StorageAdministratorSetter.contracts",
        name: "_contract",
        type: "uint8",
      },
    ],
    name: "setContractsAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_oldOwner", type: "address" },
      { internalType: "address", name: "_newOwner", type: "address" },
      { internalType: "uint96", name: "_tokenId", type: "uint96" },
    ],
    name: "transferNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "string", name: "fullName", type: "string" },
          { internalType: "string", name: "userName", type: "string" },
          { internalType: "string", name: "email", type: "string" },
          { internalType: "string", name: "phone", type: "string" },
          { internalType: "string", name: "gender", type: "string" },
          { internalType: "string", name: "country", type: "string" },
          { internalType: "uint256", name: "birthdate", type: "uint256" },
          { internalType: "string", name: "image", type: "string" },
          {
            components: [
              { internalType: "string", name: "instagram", type: "string" },
              { internalType: "string", name: "facebook", type: "string" },
              { internalType: "string", name: "tiktok", type: "string" },
              { internalType: "string", name: "youtube", type: "string" },
            ],
            internalType: "struct IPOIStorageData.SocialMedia",
            name: "socials",
            type: "tuple",
          },
        ],
        internalType: "struct IPOIStorageData.UpdateUser",
        name: "_userData",
        type: "tuple",
      },
      { internalType: "address", name: "_address", type: "address" },
    ],
    name: "updatePOIUserData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "userExists",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
];
